<template>
  <date-picker
    v-model="dateValue"
    :model-config="returnFormat"
    :locale="locale"
    :masks="{input: showFormat,}"
    :timezone="timezone"
    :mode="mode"
    v-bind="otherProps"
    class="date-color"
    :is-dark="isDark"
  >
    <template v-slot="{ inputValue, togglePopover }">
      <b-input-group>
        <b-form-input
          :placeholder="placeholder"
          :class="dateValue ? 'round-0' : ''"
          :value="typeof inputValue === 'string' ? inputValue : check(inputValue) ? check(inputValue) : getDateFromParams() ? getDateFromParams() : ''"
          :disabled="disabled"
          :readonly="readonly"
          @keydown="clear"
          @click="togglePopover()"
          class="bg-white"
        />
        <b-input-group-append
          v-if="dateValue"
          is-text
        >
          <feather-icon
            v-if="!disabled"
            icon="XIcon"
            class="cursor-pointer"
            @click="reset"
          />
        </b-input-group-append>
      </b-input-group>
    </template>
  </date-picker>
  <!-- for example -->

  <!--
      <vue-date-picker
        v-model="date"
        placeholder="sdfsdf"
        :return-format="{ type: 'string', mask: 'YYYY-MM-DD' }"
        show-format="DD.MM.YYYY"

         :other-props="{'is-range': true}"
         :other-props="{'first-day-of-week': 1}"
      />
  -->
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import {
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
} from 'bootstrap-vue'
import store from '@/store/index'

export default {
  components: {
    DatePicker,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
  },
  props: {
    // !
    value: {
      type: [String, Object],
      required: false,
      default: '',
    },
    // all Props
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    timezone: {
      type: String,
      required: false,
      default: '',
    },
    locale: {
      type: [String, Object],
      required: false,
      default: 'ru',
    },
    returnFormat: {
      type: Object,
      required: false,
      default: () => ({
        type: 'string',
        mask: 'YYYY-MM-DD',
      }),
    },
    showFormat: {
      type: String,
      required: false,
      default: 'DD.MM.YYYY',
    },
    mode: {
      type: String,
      required: false,
      default: 'date',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: true,
    },
    otherProps: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      dateValue: this.value,
      isDark: false,
    }
  },
  watch: {
    dateValue(val) {
      this.$emit('input', val)
    },
    value(val) {
      console.log(val)
      this.dateValue = val
    },
    '$store.state.appConfig.layout.skin': {
      handler(newValue){
        if(newValue === 'dark'){
          this.isDark = true
        }else{ 
          this.isDark = false
        }
      },  
      immediate: true
    }
  },
  methods: {
    reset() {
      this.dateValue = null
      this.$route.query.start_date = ""
      this.$route.query.end_date = ""
    },
    clear(e) {
      if (e.code === 'Backspace') this.dateValue = null
    },
    check(e) {
      if (e.start) {
        return `${e.start || ''}-${e.end || ''}`
      }
      return ''
    },
    getDateFromParams(){
      if(this.value && this.value.start_date && this.value.end_date){
        return `${this.value.start_date || ''}-${this.value.end_date || ''}`
      }else if(this.value && this.value.start_date2 && this.value.end_date2){
        return `${this.value.start_date2 || ''}-${this.value.end_date2 || ''}`
      }
    }
  },
}
</script>

<style>
.round-0 {
  border-right: 0;
}

/* .date-color{
  background-color: black !important;
} */
</style>
